export const MENTOR_LIST_REQUEST = 'MENTOR_LIST_REQUEST'
export const MENTOR_LIST_SUCCESS = 'MENTOR_LIST_SUCCESS'
export const MENTOR_LIST_FAIL = 'MENTOR_LIST_FAIL'